import { useState } from "react";
import { faqs } from "@/mocks/homeData";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-accent-600">
            <i className="ri-question-answer-line" />
            FAQ
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            关于吃瓜雷达，你可能想问
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-700">
            关于信源、数据口径、纠错与内容边界，我们尽量把话说清楚。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? "border-accent-300 bg-accent-50/60" : "border-background-200 bg-background-100/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="flex items-center gap-3 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs font-bold text-background-50">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {item.q}
                  </h3>
                  <i
                    className={`ri-add-line shrink-0 text-lg text-accent-600 transition-transform ${isOpen ? "rotate-45" : ""}`}
                  />
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 pl-16 text-sm leading-relaxed text-foreground-700 md:pl-[60px]">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}